import {ServerMetricName} from 'features/server/model/Server/IServerMetrics';

export type ServerMetricsRangeKey = '1h' | '24h' | '7d' | '30d';

export const SERVER_METRICS_RANGE_SECONDS: Record<ServerMetricsRangeKey, number> = {
    '1h': 3600,
    '24h': 86400,
    '7d': 7 * 86400,
    '30d': 30 * 86400,
};

export const SERVER_METRICS_DEFAULT_RANGE_KEY: ServerMetricsRangeKey = '1h';

export const SERVER_METRICS_RANGE_PARAM = 'range';

export const SERVER_METRICS_POLLING_INTERVAL = 60000;

export const SERVER_METRICS_UPTIME_MAX_DRIFT_SECONDS = 600;

export const SERVER_METRICS_MIN_WINDOW_SECONDS = 300;

export const SERVER_METRICS_CPU: ServerMetricName[] = ['cpu_user', 'cpu_system', 'cpu_iowait', 'cpu_steal'];
export const SERVER_METRICS_LA: ServerMetricName[] = ['la1', 'la5', 'la15'];
export const SERVER_METRICS_MEM_QUERY: ServerMetricName[] = [
    'mem_total', 'mem_available', 'swap_total', 'swap_used',
];
